import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'cutiService'

const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const cutiList = 'Kepegawaian/cuti/list/'
export const cutiInactive = 'Kepegawaian/cuti/inactive/'
export const cutiCreate = 'Kepegawaian/cuti/create/'
export const cutiUpdate = 'Kepegawaian/cuti/update/'
export const cutiDetail = 'Kepegawaian/cuti/detail/'
export const cutiApproval = 'Kepegawaian/cuti/approval/'
export const cutiCancel = 'Kepegawaian/cuti/cancel/'
export const cutiCancelAdmin = 'Kepegawaian/cuti/cancelAdmin/'
export const cutiApproveRekove = 'Kepegawaian/cuti/approveRevoke/'
export const cutiListBawahan = 'Kepegawaian/cuti/listBawahan/'
export const listAtasan = 'Kepegawaian/cuti/listAtasan/'
//new rekap cuti
export const rekapCuti = 'Kepegawaian/cuti/rekapCuti/'
export const rekap = 'Kepegawaian/cuti/rekap/'

// New cancel cuti
export const cutiSubmitCancel = 'Kepegawaian/cuti/submitCancel/'

export const cutiKuotaTahunan = 'Kepegawaian/cuti/getYearQuota/'
export const EmployeeDetail = 'Kepegawaian/cuti/employee/'
export const cutiTypeList = 'Kepegawaian/cuti/typeList/'
export const cutiChildTypeList = 'Kepegawaian/cuti/childTypeList/'
export const signatoriesList = 'Kepegawaian/cuti/signatoriesList/'

export const getMinDate = 'Kepegawaian/cuti/getMinDate/'
export const checkDate = 'Kepegawaian/cuti/checkDate/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}